export { default } from '../../../containers/seller-profile/index';

